import { AttributeDefinitionModel } from "./";

export class AuctionLotAttributeModel {
    Id: number;
    AuctionLotId: number;
    AttributeDefinitionId: number;
    Quantity: number;

    AttributeDefinition: AttributeDefinitionModel;
}